import React, { forwardRef, isValidElement } from 'react';
import { Title } from '../../../webComponents/Title/index.js';
const styles = {
  minHeight: '1.5rem',
  display: 'flex',
  alignItems: 'center'
};
export const TitleBar = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    titleBarId
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    style: styles,
    ref: ref,
    id: titleBarId
  }, typeof children === 'string' && /*#__PURE__*/React.createElement(Title, null, children), /*#__PURE__*/isValidElement(children) && children);
});
TitleBar.displayName = 'TitleBar';